import * as React from 'react';
import styles from './index.less';
import { Space } from 'antd';
import Task from './Task';
import * as AHooks from 'ahooks';
import { FI18n, FServiceAPI, FUtil } from '@freelog/tools-lib';
import FComponentsLib from '@freelog/components-lib';
import fPromiseModalConfirm from '@/components/fPromiseModalConfirm';
import type { RcFile } from 'antd';
import fMessage from '@/components/fMessage';
import { FRegExpMgr } from '@/utils/FRegExpMgr';
import FIcons from '@/components/FIcons';
import { UploadStatus, useStorageUploadTasks } from './useStorageUploadTasks';
import FSimpleBar from '../FSimpleBar';

export interface FStorageUploadTasksPanel2Props {
  bucketName: string;
  availableStorageSize: number;

  onSuccess?(): void;
  onChange_incompleteTask?(bool: boolean): void;
}

interface FStorageUploadTasksPanel2States {
  // uploadTaskQueue: {
  //   uid: string;
  //   file: RcFile;
  //   name: string;
  //   state: 'loading' | 'success' | 'failed';
  // }[];
  uploadPanelVisible: boolean;
  uploadPanelOpen: boolean;
}

const initStates: FStorageUploadTasksPanel2States = {
  // uploadTaskQueue: [],
  uploadPanelVisible: false,
  uploadPanelOpen: false,
};

interface TasksPanel {
  addTask(files: RcFile[]): void;
}

let storageUploadTasksPanel: TasksPanel | null = null;

function FStorageUploadTasksPanel2({
  bucketName,
  availableStorageSize,
  onSuccess,
  onChange_incompleteTask,
}: FStorageUploadTasksPanel2Props) {
  const latestBucketNameRef = AHooks.useLatest(bucketName);
  const availableStorage = React.useRef<number>(availableStorageSize);
  const [uploadPanelVisible, set_uploadPanelVisible] = React.useState<
    FStorageUploadTasksPanel2States['uploadPanelVisible']
  >(initStates['uploadPanelVisible']);
  const [uploadPanelOpen, set_uploadPanelOpen] = React.useState<
    FStorageUploadTasksPanel2States['uploadPanelOpen']
  >(initStates['uploadPanelOpen']);

  const { list, successList, getList, addFiles, resumeUpload, pauseUpload, clearAll } =
    useStorageUploadTasks();

  AHooks.useMount(() => {
    const panel = {
      addTask,
    };
    storageUploadTasksPanel = panel;
  });

  AHooks.useUnmount(() => {
    storageUploadTasksPanel = null;
  });

  React.useEffect(() => {
    availableStorage.current = availableStorageSize;
  }, [availableStorageSize]);

  AHooks.useThrottleEffect(
    () => {
      // console.log(
      //   'successList useThrottleEffect ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^',
      //   successList,
      // );
      if (successList.length > 0) {
        onSuccess?.();
      }
    },
    [successList],
    {
      wait: 500,
    },
  );

  React.useEffect(() => {
    onChange_incompleteTask?.(
      list.some((task) => {
        return task.status !== UploadStatus.COMPLETED;
      }),
    );
  }, [list]);

  const addTask = React.useCallback(
    (files: RcFile[]) => {
      for (const file of files) {
        if (file.size > 200 * 1024 * 1024) {
          fMessage('单个文件不能大于 200 M', 'warning');
          return;
        }
      }

      const totalSize: number = files.map((f) => f.size).reduce((p, c) => p + c, 0);
      // console.log(availableStorageSize, totalSize, 'use');
      if (availableStorage.current < totalSize) {
        fMessage(FI18n.i18nNext.tAuto('uploadobject_alarm_storage_full'), 'error');
        return;
      }

      addFiles(
        files.map((f) => ({
          fileID: f.uid,
          file: f,
          bucketName: latestBucketNameRef.current,
        })),
      );
      // });

      set_uploadPanelVisible(true);
      set_uploadPanelOpen(true);
      // set_uploadTaskQueue([...taskQueue, ...get_uploadTaskQueue()]);
    },
    [bucketName],
  );

  function closeAll() {
    set_uploadPanelVisible(false);
    clearAll();
  }

  if (!uploadPanelVisible && list.length === 0) {
    return null;
  }

  return (
    <div className={styles.UploadingTasks}>
      <div className={styles.title}>
        <FComponentsLib.FContentText text={'任务列表'} />
        <Space size={20}>
          <FComponentsLib.FTextBtn
            onClick={() => {
              set_uploadPanelOpen(!uploadPanelOpen);
            }}
            type='default'
          >
            {uploadPanelOpen ? (
              <FIcons.FDown style={{ fontSize: 12 }} />
            ) : (
              <FIcons.FUp style={{ fontSize: 12 }} />
            )}
          </FComponentsLib.FTextBtn>
          <FComponentsLib.FTextBtn
            onClick={async () => {
              const isExits: boolean = getList().some((i) => {
                return i.status !== UploadStatus.COMPLETED;
              });
              if (isExits) {
                const bool: boolean = await fPromiseModalConfirm({
                  title: '提示',
                  description: FI18n.i18nNext.t('bucket_msg_cancel_all_uploading_task'),
                  cancelText: FI18n.i18nNext.t('bucket_btn_countinue_upload'),
                  okText: FI18n.i18nNext.t('bucket_btn_cancel_upload'),
                });
                if (bool) {
                  closeAll();
                }
                return;
              }
              closeAll();
            }}
            type='default'
          >
            <FIcons.FClose style={{ fontSize: 12 }} />
          </FComponentsLib.FTextBtn>
        </Space>
      </div>
      <div style={{ borderTop: '1px solid #E5E5E5' }} />
      <FSimpleBar height={uploadPanelOpen ? 370 : 0}>
        <div
          className={styles.body}
          // style={{ display: uploadPanelOpen ? 'block' : 'none' }}
        >
          {list.some((task) => {
            return task.status === UploadStatus.COMPLETED;
          }) && (
            <div className={styles.successCount}>
              有
              {
                list.filter((task) => {
                  return task.status === UploadStatus.COMPLETED;
                }).length
              }
              个文件上传成功
            </div>
          )}

          {list.map((task, index, list) => {
            return (
              <Task
                key={task.fileID}
                task={task}
                on_Uploading_Cancel={() => {
                  pauseUpload(task.fileID);
                }}
                on_Canceled_ReUpload={() => {
                  // addFiles([task]);
                  resumeUpload(task.fileID, UploadStatus.CANCELED);
                }}
                on_SameName_ReUpload={() => {
                  resumeUpload(task.fileID, UploadStatus.SAME_NAME);
                }}
                on_Failed_ReUpload={() => {
                  // addFiles([task]);
                }}
              />
            );
          })}
        </div>
      </FSimpleBar>
    </div>
  );
}

export default FStorageUploadTasksPanel2;

export async function getStorageUploadTasksPanel2(): Promise<TasksPanel> {
  while (true) {
    if (storageUploadTasksPanel) {
      return storageUploadTasksPanel;
    }
    await FUtil.Tool.promiseSleep(300);
  }
}
